/**
 * Detect fn
 */
export default () => 'isFrozen' in Object
